/**
 * GINGADO STORE — Preço Riscado Automático
 * 
 * Como usar no Shopify:
 * 1. Acesse: Admin → Loja Online → Temas → Editar código
 * 2. Abra o arquivo: assets/theme.js  OU  layout/theme.liquid
 * 3. Cole este script antes do </body> no theme.liquid
 *    OU adicione como novo arquivo .js e chame com <script src="{{ 'gingado-preco-riscado.js' | asset_url }}"></script>
 */

(function () {

  /**
   * Gera um seed baseado no ID/handle do produto
   * para que o % seja sempre o mesmo por produto (não muda ao recarregar)
   */
  function seededRandom(seed) {
    let x = Math.sin(seed + 1) * 10000;
    return x - Math.floor(x);
  }

  /**
   * Retorna a faixa de % extra baseado no preço real
   * Quanto menor o preço → maior o % de aumento
   */
  function getPercentRange(priceReal) {
    if (priceReal <= 50)        return [180, 205];
    if (priceReal <= 150)       return [140, 180];
    if (priceReal <= 300)       return [120, 140];
    return                             [100, 120];
  }

  /**
   * Calcula o preço riscado para um produto
   * @param {number} priceReal - preço real em R$
   * @param {number} productSeed - seed único do produto (ex: ID numérico)
   * @returns {number} preço riscado
   */
  function calcPrecoRiscado(priceReal, productSeed) {
    const [min, max] = getPercentRange(priceReal);
    const rand = seededRandom(productSeed);
    const percent = min + rand * (max - min); // ex: 163.4%
    return Math.ceil(priceReal * (1 + percent / 100));
  }

  /**
   * Formata número em moeda BR
   */
  function formatBRL(value) {
    return value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
    });
  }

  /**
   * Aplica os preços riscados na página
   * Procura elementos com o atributo data-gingado-price
   * 
   * No seu tema, adicione nos cards de produto:
   *   data-gingado-price="{{ product.price | divided_by: 100.0 }}"
   *   data-gingado-seed="{{ product.id }}"
   */
  function aplicarPrecoRiscado() {
    const elementos = document.querySelectorAll('[data-gingado-price]');

    elementos.forEach(function (el) {
      const priceReal = parseFloat(el.getAttribute('data-gingado-price'));
      const seed = parseInt(el.getAttribute('data-gingado-seed')) || 42;

      if (isNaN(priceReal) || priceReal <= 0) return;

      const precoRiscado = calcPrecoRiscado(priceReal, seed);

      // Busca os elementos filhos de preço
      const elRiscado = el.querySelector('.gingado-preco-riscado');
      const elReal    = el.querySelector('.gingado-preco-real');

      if (elRiscado) elRiscado.textContent = formatBRL(precoRiscado);
      if (elReal)    elReal.textContent    = formatBRL(priceReal);
    });
  }

  // Roda quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', aplicarPrecoRiscado);
  } else {
    aplicarPrecoRiscado();
  }

  // Expõe a função globalmente caso precise chamar manualmente
  window.GingadoPreco = {
    calcPrecoRiscado: calcPrecoRiscado,
    aplicarPrecoRiscado: aplicarPrecoRiscado
  };

})();

/* ============================================================
   EXEMPLO DE HTML no template de produto/coleção do Shopify:
   ============================================================

   <div data-gingado-price="{{ product.price | divided_by: 100.0 }}"
        data-gingado-seed="{{ product.id }}">

     <span class="gingado-preco-riscado" style="text-decoration: line-through; color: #999; font-size: 0.9em;">
       Carregando...
     </span>

     <span class="gingado-preco-real" style="font-weight: bold; color: #000;">
       Carregando...
     </span>

   </div>

   ============================================================ */
